import { createTheme } from "@mui/material";
import { navbarTheme } from "./navbarTheme";
const defaultTheme = createTheme({
    name: "ssf",
    typography: {
        fontFamily: '"Lato", sans-serif',
        fontFamilyTertiary: '"Montserrat", sans-serif',
    },
});
export const theme = createTheme({
    name: "ssf",
    palette: {
        background: {
            default: defaultTheme.palette.grey.A100,
        },
        primary: {
            main: "#171717",
        },
        success: {
            main: "#4caf50",
            contrastText: "#FFF",
        },
    },
    typography: {
        ...defaultTheme.typography,
        fontWeightMedium: 400,
        fontWeightBold: 700,
        h1: {
            // ...defaultTheme.typography.h2,
            fontSize: 32,
            lineHeight: "38px",
            fontWeight: 700,
        },
        h2: {
            fontSize: 24,
            lineHeight: "28px",
            fontWeight: 700,
        },
        h3: {
            fontSize: 20,
            lineHeight: "24px",
            fontWeight: 700,
        },
        h4: {
            fontSize: 18,
            lineHeight: "18px",
            fontWeight: 700,
        },
        h5: {
            fontSize: 16,
            lineHeight: "19px",
            fontWeight: 700,
        },
    },
    components: {
        MuiContainer: {
            defaultProps: {
                fixed: true,
                maxWidth: "md",
            },
        },
        MuiDialogTitle: {
            defaultProps: {
                variant: "h3",
            },
        },
    },
    Navbar: navbarTheme,
});
export const clubTheme = createTheme({
    ...theme,
    name: "club",
    palette: {
        ...theme.palette,
        primary: {
            main: "#5C3369",
            contrastText: "#FFF",
        },
    },
});
export const s4Theme = createTheme({
    ...theme,
    name: "s4",
    palette: {
        ...theme.palette,
        primary: {
            main: "#82c440",
            contrastText: "#FFF",
        },
    },
});
export const sisTheme = createTheme({
    ...theme,
    name: "sis",
    palette: {
        ...theme.palette,
        primary: {
            main: "#bf175d",
            contrastText: "#FFF",
        },
    },
});
export const regTheme = createTheme({
    ...theme,
    name: "reg",
    palette: {
        ...theme.palette,
        primary: {
            main: "#218ebe",
            contrastText: "#FFF",
        },
    },
});
export const playTheme = createTheme({
    ...theme,
    name: "play",
    palette: {
        ...theme.palette,
        primary: {
            main: "#bf2517",
            contrastText: "#FFF",
        },
    },
});
export const drakensSchackhusTheme = createTheme({
    ...theme,
    name: "drakensSchackhus",
    palette: {
        ...theme.palette,
        primary: {
            main: "#01938E",
            contrastText: "#FFF",
        },
    },
});
//# sourceMappingURL=theme.js.map